import type { ReferenceField } from '@uncinc/react-drupal-core/types';

import type { NodePartner } from '../../../types/uncinc_profile/nodes';
import type { Partner } from '.';

export default function nodePartnersWidgetMapper(partners: ReferenceField<NodePartner>[]): Partner[] {
  return partners.map((partner) => (
    {
      name: partner.entity.title[0].value,
      url: partner.entity.field_link[0].uri,
    }
  ));
}
